import React from 'react';
import { motion } from 'framer-motion';
import './Experience.css';

const experiences = [
  {
    company: 'Webfuel Agency',
    role: 'Full Stack Developer',
    period: '2023 – 2026',
    description: 'Building and maintaining the Inspired Learning platform with Laravel and Joomla CMS, while collaborating on the Gigasure project to deliver scalable web solutions.',
    technologies: ['Laravel', 'Joomla', 'PHP', 'MySQL'],
  },
  {
    company: 'Boostly',
    role: 'Full Stack Developer',
    period: '2023 – 2025',
    description: 'Custom WordPress plugins and themes backed by Laravel, improving site functionality and user experience with robust, reliable solutions that streamline operations.',
    technologies: ['WordPress', 'Laravel', 'PHP', 'MySQL'],
  },
  {
    company: 'Tas Tradesoft',
    role: 'Full Stack Developer',
    period: '2022 – 2023',
    description: 'Dynamic, responsive web applications in Angular and Node.js, plus the server-side services behind them.',
    technologies: ['Angular', 'Node.js', 'TypeScript', 'REST APIs'],
  },
  {
    company: 'CrowdConnect',
    role: 'Mobile Developer',
    period: '2019 – 2022',
    description: 'Cross-platform mobile applications with seamless user experiences, integrating the Firebase SDK for backend functionality.',
    technologies: ['Ionic', 'Firebase', 'Angular', 'TypeScript'],
  },
  {
    company: 'KnightSpear',
    role: 'Full Stack Developer',
    period: '2017 – 2018',
    description: 'RESTful APIs, dynamic Angular interfaces and Node.js back ends on MongoDB.',
    technologies: ['Angular', 'Node.js', 'MongoDB', 'REST APIs'],
  },
];

const Experience = () => (
  <section id="career" className="career wrap">
    <div className="section-head">
      <h2 className="display display-xl">
        Since{' '}<br /><span className="accent">2017.</span>
      </h2>
      <p className="section-note">
        Five teams across the UK, Germany and the Philippines — agencies, startups and
        product companies, all remote.
      </p>
    </div>

    <ol className="career-list">
      {experiences.map((exp, i) => (
        <motion.li
          key={exp.company}
          className="career-row"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5, delay: i * 0.05 }}
        >
          <span className="career-period mono">{exp.period}</span>
          <div className="career-who">
            <h3 className="career-company">{exp.company}</h3>
            <span className="career-role mono">{exp.role}</span>
          </div>
          <p className="career-desc">{exp.description}</p>
          <div className="career-tech">
            {exp.technologies.map((tech) => (
              <span key={tech} className="tag">{tech}</span>
            ))}
          </div>
        </motion.li>
      ))}
    </ol>
  </section>
);

export default Experience;
